<section class="flex justify-center items-center">
  <div class="table-skeleton w-full border-collapse">
    <div class="skeleton-row header h-[60px] flex items-center gap-4 px-3">
      <div class="skeleton-cell w-[70px] h-[20px]"></div>
      <div class="skeleton-cell w-[125px] h-[20px]"></div>
      <div class="skeleton-cell w-[200px] h-[20px]"></div>
      <div class="skeleton-cell w-[225px] h-[20px]"></div>
      <div class="skeleton-cell sm:hidden xl:block w-[125px] h-[20px]"></div>
    </div>
    <div *ngFor="let table of [1, 1, 1, 1, 1, 1, 1, 1, 1]">
      <div
        class="skeleton-row shadow-md h-[58px] flex items-center gap-28 px-3"
      >
        <div class="skeleton-cell w-[70px] h-[20px]"></div>
        <div class="skeleton-cell w-[155px] h-[20px]"></div>
        <div class="skeleton-cell w-[225px] h-[20px]"></div>
        <div class="skeleton-cell w-[255px] h-[20px]"></div>
        <div class="skeleton-cell sm:hidden xl:block w-[155px] h-[20px]"></div>
      </div>
    </div>
    <div
      class="skeleton-row header h-[60px] flex items-center justify-end px-3"
    >
      <div class="flex gap-2">
        <div class="flex flex-col items-end gap-1 justify-center">
          <div class="skeleton-cell w-[165px] h-[15px]"></div>
          <div class="skeleton-cell w-[240px] h-[15px]"></div>
        </div>
        <div class="skeleton-cell paginator w-[60px] h-[50px]"></div>
      </div>
    </div>
  </div>
</section>
